import SupportTicketDetail from "@/components/SupportTicketDetail/SupportTicketDetail";
import { useParams } from "react-router-dom";
export default function GoToPage() {
  const { id } = useParams();
  return <SupportTicketDetail id={id} />;
}
